import { render, staticRenderFns } from "./NavbarCollapseIcon.vue?vue&type=template&id=5943e59a&scoped=true&"
import script from "./NavbarCollapseIcon.vue?vue&type=script&lang=js&"
export * from "./NavbarCollapseIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCollapseIcon.vue?vue&type=style&index=0&id=5943e59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5943e59a",
  null
  
)

export default component.exports